import { type ReactNode, useState } from "react";
import { NavDrawer } from "./components/NavDrawer";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";

/** Header, mobile drawer, footer and backdrop shared by every logged-out
 * page (landing, /products, /products/{slug}). */
export function SiteLayout({ children }: { children: ReactNode }) {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[var(--background)] text-[var(--foreground)]">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded-lg focus:bg-[var(--surface-solid)] focus:px-4 focus:py-2 focus:text-sm focus:font-medium"
      >
        Skip to content
      </a>

      {/* Decorative backdrop — hidden from assistive tech and forced-colors mode. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 -z-0 overflow-hidden forced-colors:hidden"
      >
        <div className="mx-auto h-72 max-w-6xl bg-[radial-gradient(40rem_16rem_at_50%_-4rem,var(--muted-strong),transparent)]" />
      </div>

      <SiteHeader onMenuClick={() => setNavOpen(true)} menuOpen={navOpen} />
      <NavDrawer open={navOpen} onClose={() => setNavOpen(false)} />

      <main id="main" className="relative">
        {children}
      </main>

      <SiteFooter />
    </div>
  );
}
